import { createSelector } from 'reselect';
import type { ProductFlag } from '../../../../shared/constants/productFlipperFlagRelation';
import type { ProductFlagValues } from '../../../../shared/ProductFlipperFlag.service';
import { ProductFlagService } from '../../../../shared/ProductFlag.service';
import { getFlipperFlagValues } from './FlipperSelectors';
import { ProductSuite, PRODUCT_SUITE_FLAGS } from '../../../../shared/constants/productFlags';

function getProductName(state: any, productName: ProductFlag): string {
  return productName;
}

function getProductSuite(state: any, productSuite: ProductSuite): ProductSuite {
  return productSuite;
}

export function getProductFlagValues(): ProductFlagValues {
  return (<any>window)?.App?.context?.ppp || {};
}

export const isProductEnabled: (state: any, productName: ProductFlag) => boolean = createSelector(
  getFlipperFlagValues,
  getProductFlagValues,
  getProductName,
  (flipperFlags, productFlags, productName) => {
    return new ProductFlagService().isProductFlagEnabled(productName, productFlags, flipperFlags);
  }
);

export const isProductStrictlyEnabled: (state: any, productName: ProductFlag) => boolean = createSelector(
  getProductFlagValues,
  getProductName,
  (productFlags, productName) => {
    return new ProductFlagService().isProductFlagEnabled(productName, productFlags, {});
  }
);

export const hasProductSuite: (state: any, productSuite: ProductSuite) => boolean = createSelector(
  getFlipperFlagValues,
  getProductFlagValues,
  getProductSuite,
  (flipperFlags, productFlags, productSuite) => {
    return PRODUCT_SUITE_FLAGS[productSuite].every((product) => {
      return new ProductFlagService().isProductFlagEnabled(product, productFlags, flipperFlags);
    });
  }
);
